const Images = {
  kgLogo: require("./Images/KGUltraLogo.png"),
  kgInternationalLogo: require("./Images/KGInternationalLogo.png"),
  failedComponentsSample1: require("./Images/FailedComponentsSample1.png"),
  failedComponentsSample2: require("./Images/FailedComponentsSample2.png"),
  successPopupImage: require("./Images/SuccessPopupImage.png"),
  coverImage : require("./Images/coverImg.jpg"),
  pdfBar: require("./Images/pdfbar.png")
  };
  
  const Icons = {
    activeDashboardIcon: require("./Icons/activeDashboard.png"),
    activeRequestIcon: require("./Icons/activeReport.png"),
    activeCompanyManagementIcon: require("./Icons/activeCompanyManagement.png"),
    activeContentManagementIcon: require("./Icons/activeContentManagement.png"),
    activeUserManagementIcon: require("./Icons/activeUsersManagement.png"),
    activeStaffManagementIcon: require("./Icons/activeStaffManagement.png"),
    activeSettingsIcon: require("./Icons/activeSettings.png"),
    dashboardIcon: require("./Icons/Dashboard.png"),
    companyManagementIcon: require("./Icons/CompanyManagement.png"),
    contentManagementIcon: require("./Icons/ContentManagement.png"),
    requestIcon: require("./Icons/Request.png"),
    staffManagementIcon: require("./Icons/StaffManagement.png"),
    settingsIcon: require("./Icons/Settings.png"),
    usersManagementIcon: require("./Icons/UsersManagement.png"),
    closeIcon:require("./Icons/closeIcon.png"),
    userIcon:require("./Icons/userIcon.png"),
    minimizeIcon:require("./Icons/minimizeIcon.png"),
    notificationIcon:require("./Icons/notification.png"),
    activeUsersIcon:require("./Icons/ActiveUsers.png"),
    inActiveUsers:require("./Icons/InActiveUsers.png"),
    noOfCompanies:require("./Icons/NoOfCompanies.png"),
    noOfUsers:require("./Icons/NoOfUsers.png"),
    sort:require("./Icons/sort.png"),
    calendar:require("./Icons/calendar.png"),
    avatar:require("./Icons/avatar.png"),
    leftArrow:require("./Icons/leftArrow.png"),
    rightArrow:require("./Icons/rightArrow.png"),
    backArrow:require("./Icons/backArrow.png"),
    searchIcon:require("./Icons/searchIcon.png"),
    optionsIcon:require("./Icons/optionsIcon.png"),
    viewIcon:require("./Icons/viewIcon.png"),
    editIcon:require("./Icons/editIcon.png"),
    deleteIcon:require("./Icons/deleteIcon.png"),
    activeInactiveIcon:require("./Icons/activeInactiveIcon.png"),
    creditsLogo:require("./Icons/creditsLogo.png"),
    stepperActiveIcon:require("./Icons/activeStepperIcon.png"),
    stepperInActiveIcon:require("./Icons/inActiveStepperIcon.png"),
    uploadIcon:require("./Icons/uploadIcon.png"),
    kgLogo:require("./Icons/KGLogo.png"),
    downloadIcon : require("./Icons/download.png"),
    contactEnquiriesIcon: require("./Icons/contact_enquiries.png"),
    requestIconNew: require("./Icons/Request_icon.png"),
  };
  
  const Lottie = {};
  
  const ExportedData = {
    Images,
    Icons,
    Lottie,
  };
  
  export default ExportedData;
  